<template>
  <div class="home" :class="{ home_out_app: !isKkmh() }">
    <div class="top_bar">
      <div class="back_btn" @click="close" v-show="isKkmh()">
        <img src="./img/back-icon.png" alt />
      </div>
      <div class="share_btn" @click="showShare" v-show="isKkmh()">
        <img src="./img/share-icon.png" />
      </div>
    </div>
    <div class="banner">
      <img src="./img/banner.png" alt />
    </div>

    <div class="rule_entrance" @click="showRule">
      <div>活动规则</div>
    </div>

    <!-- 平台展示+预约+开通按钮 -->
    <platform></platform>

    <!-- 超级会员权益 -->
    <member-auth></member-auth>

    <!-- 活动规则弹窗 -->
    <rule></rule>

    <!-- 挽留弹窗 -->
    <detention></detention>

    <!-- 分享弹窗 -->
    <share></share>

    <!-- 预约获取手机号弹窗 -->
    <order-phone></order-phone>

    <!-- 全局loading -->
    <loading></loading>

    <!-- 权益tab栏吸顶 -->
    <div
      class="auth_top_fix_bar"
      :class="{
        auth_top_fix_bar_show: show_auth_tab,
        kuaikan_app_full: isKkmh() && show_auth_tab,
        auth_top_fix_bar_android: isKkmh() && show_auth_tab && is_long_android,
      }"
    >
      <div
        class="kuaikan_tab"
        :class="{ tab_chosen: chosen_tab == 'kuaikan' }"
        @click="switchTab('kuaikan')"
      >
        <img
          class="kuaikan_unchosen"
          src="./img/kuaikan_tab_unchosen.png"
          v-show="chosen_tab == 'other'"
          alt
        />
        <img
          class="kuaikan_chosen"
          src="./img/kuaikan_tab_chosen.png"
          alt
          v-show="chosen_tab == 'kuaikan'"
        />
      </div>
      <div
        class="other_tab"
        :class="{ tab_chosen: chosen_tab == 'other' }"
        @click="switchTab('other')"
      >
        <img
          class="other_unchosen"
          src="./img/others_tab_unchosen.png"
          v-show="chosen_tab == 'kuaikan'"
          alt
        />
        <img
          class="other_chosen"
          src="./img/others_tab_chosen.png"
          v-show="chosen_tab == 'other'"
          alt
        />
      </div>
    </div>

    <!-- 娱乐应用特权tab吸顶 -->
    <div
      class="plat_top_fix_bar"
      :class="{
        plat_top_fix_bar_show: show_plat_tab,
        plat_top_kuaikan_app_full: isKkmh() && show_plat_tab,
        plat_top_kuaikan_app_full_android:
          isKkmh() && show_auth_tab && is_long_android,
      }"
    >
      <plat-icon-slide></plat-icon-slide>
    </div>

    <!-- 开通按钮吸底 -->
    <div
      class="bottom_fix_bar"
      :class="{
        bottom_fix_bar_show: show_open_fix,
        bottom_fix_bar_show_app_full: isKkmh() && show_open_fix,
      }"
    >
      <div class="open_btn_fix">
        <open-btn :from="btn_from"></open-btn>
      </div>
    </div>

    <!-- 活动结束页 -->
    <div class="end_page" v-show="activity_status == 4" @touchmove.prevent>
      <div class="back_btn" @click="close">
        <img src="./img/back-icon.png" />
      </div>
      <div class="end_content">
        <img class="end_icon" src="./img/end_icon.png" />
        <div class="end_tips">活动已结束</div>
        <div class="end_tips">下次再来哦～</div>
      </div>
    </div>

    <!-- 百度方遮罩 -->
    <div class="baidu_mask" @touchmove.prevent v-show="from_baidu || miniback">
      <div class="dard_mask"></div>
      <div class="baidu_btn_container">
        <div
          class="from_baidu_btn from_baidu_open_btn"
          v-show="baidu_open_disable == 2"
          @click="callOutAppPay"
        >
          继续购买
        </div>
        <div class="from_baidu_btn" v-show="baidu_open_disable == 3">
          <!-- <div>已经开通四次</div> -->
          <div class="from_baidu_get_btn" @click="jumpToGetPage">领取权益</div>
          <div class="from_baidu_disable_btn" @click="jumpToGetPage">
            开通次数已用光
          </div>
        </div>
        <div class="from_baidu_btn" v-show="baidu_open_disable == 4">
          <div class="form_baidu_double_btn">
            <div class="from_baidu_get_btn_right" @click="callOutAppPay">
              继续购买
            </div>
            <div class="from_baidu_get_btn_left" @click="jumpToGetPage">
              领取权益
            </div>
          </div>
        </div>
        <div
          class="from_baidu_btn from_baidu_disable_btn"
          v-show="baidu_open_disable == 5"
        >
          <!-- 同设备用其他账号买过4次，显示活动结束按钮 -->
          开通次数已用光
        </div>
        <div class="baidu_jump_btn back_baidu_btn" @click="jumpBaidu">
          返回主页
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapState, mapMutations } from "vuex";
// api
import { phoneReservationStatus } from "./api/phone_reservation_status.api";
import { homePage } from "./api/home_page.api";
import { listH5 } from "./api/member_good_list_h5.api";
import { h5List } from "./api/member_good_h5_list.api";
import { vipMe } from "./api/vip_me.api";

import {
  initMini,
  miniprogramNav,
} from "@/assets/fe_js/common/miniprogram/utils";
import { fix, unfix } from "./js/fix_ele";

// comp
import Platform from "./comp/Platform";
import MemberAuth from "./comp/MemberAuth";
import Rule from "./comp/Rule";
import Detention from "./comp/Detention";
import Share from "./comp/Share";
import OrderPhone from "./comp/OrderPhone";
import PlatIconSlide from "./comp/PlatIconSlide";
import OpenBtn from "./comp/OpenBtn";
import Loading from "./comp/Loading";

const { log } = console;
export default {
  data() {
    return {
      show_auth_tab: false, // 权益tab吸顶
      show_plat_tab: false, // 娱乐应用tab吸顶
      show_open_fix: false, // 开通按钮吸底

      btn_from: "bottom", // 埋点用按钮来源

      is_long_android: false, // 处理安卓刘海屏

      // baidu_open_disable: false, // 百度端进入页面判断是否开通达到4次
    };
  },
  components: {
    Platform,
    MemberAuth,
    Rule,
    Detention,
    Share,
    OrderPhone,
    PlatIconSlide,
    OpenBtn,
    Loading,
  },
  watch: {
    refresh_data: function () {
      if (this.refresh_data) {
        log("刷新首页数据----");
        this.baseInit("refresh");
        this.SET_COMP_INIT(false);
        this.SET_REFRESH_DATA(false);
      }
    },
    refresh_membergood_list: function () {
      if (this.refresh_membergood_list) {
        log("刷新价格接口----");
        // this.getMemberGoodListH5(true);
        // this.this.getOpenPrice(true);
        if (this.$kkmh.ua().kkmh) {
          this.getMemberGoodListH5(false);
        } else {
          this.getMemberGoodListBrowser();
        }
      }
    },
  },
  computed: {
    ...mapState([
      "is_login",
      "chosen_tab",
      "activity_status",
      "can_assign_count",
      "user_id",
      "server_time",
      "xdevice",
      "activity_name",
      "activity_name_topic",
      "third_activity",
      "is_jailbroken_phone_url",
      "is_jailbroken_phone",
      "refresh_data",
      "refresh_membergood_list",
      "time_end",
      // "open_price",
      "baidu_open_disable",
    ]),

    from_baidu: function () {
      if (this.$kkmh.qs()["from"] == "baidu") {
        return true;
      } else {
        return false;
      }
    },
    miniback: function () {
      if (this.$kkmh.qs()["miniback"] == "baidu") {
        return true;
      } else {
        return false;
      }
    },
  },
  created: function () {},
  mounted: function () {
    // 初始化
    this.listenInit();
    // 固定home，骨架屏中禁止底部滑动
    this.fixHome();
    // 处理安卓刘海屏
    this.handleAndroidTopBar();
  },

  methods: {
    ...mapMutations([
      "SET_CHOSEN_TAB",
      "SET_SHOW_RULE",
      "SET_SHOW_SHARE",
      "SET_SHOW_PHONE_NUMBER",
      "SET_SHOW_DETENTION",
      "SET_XDEVICE",
      "SET_IS_LOGIN",
      "SET_MEMBERSHIP_CLASSIFY",
      "SET_CAN_TRACK",
      "SET_IS_JAILBROKEN_PHONE",
      "SET_APP_VERSION",
      "SET_USERID",
      "SET_RESERVATION_STATUS",
      "SET_ACTIVITY_STATUS",
      "SET_CAN_ASSIGN_COUNT",
      "SET_SEVER_TIME",
      "SET_TOTAL_COUNT",
      "SET_SALE_COUNT",
      "SET_PLAT_ICONS",
      "SET_OPEN_PRICE",
      "SET_REFRESH_DATA",
      "SET_ACTIVITY_END_TIME",
      "SET_COMP_INIT",
      "SET_PROGRESS_WIDTH",
      "SET_IS_IPAD",
      "SET_MEMBER_REMAIN_DAYS",
      "SET_SHOW_NINE",
      "SET_CALL_APPPAY",
    ]),
    // 处理安卓刘海屏
    handleAndroidTopBar() {
      var innerHeight = window.innerHeight,
        innerWidth = window.innerWidth;

      if (innerHeight / innerWidth > 1.8 && this.$kkmh.ua().android) {
        this.is_long_android = true;
      }
    },
    // home固定
    fixHome() {
      let fixele = document.querySelector(".home");
      fix(fixele);
    },
    // home解除固定
    unfixHome() {
      let fixele = document.querySelector(".home");
      unfix(fixele);
    },
    // 隐藏骨架屏
    hideSkeletonScreen() {
      setTimeout(() => {
        window.skeletonScreen.hide();
        this.SET_PROGRESS_WIDTH(true);
        this.unfixHome();
      }, 1000);
    },
    // 端内外
    isKkmh() {
      return this.$kkmh.ua().kkmh;
    },
    // 小程序中设置cookie_device,传给接口
    setMiniProgram() {
      let kkid = this.$kkmh.qs()["kkid"];
      if (kkid == undefined) {
        return;
      }
      kkid = decodeURIComponent(kkid);
      let open_id = kkid.split(":")[1].split("#")[0];
      let uid = kkid.split("#")[1];
      document.cookie = `cookie_device=${open_id}`;

      return Promise.resolve();
    },
    // h5初始化完成
    listenInit() {
      let _this = this;
      if (window.__nativeInit) {
        log("监听全局保存变量", window.__gvalkkmh);
        this.baseInit();
        return false;
      }
      Object.defineProperty(window, "__nativeInit", {
        get: function () {},
        set: function (val) {
          if (val) {
            log("监听全局保存变量", window.__gvalkkmh);
            _this.baseInit();
          }
        },
      });
    },
    baseInit(refresh = "") {
      // 获取设备信息
      this.setUserAndDeviceInfo();
      // 小程序初始化
      initMini();
      // 初始化请求
      this.reqInit(refresh);
    },
    // 初始化请求
    reqInit(refresh) {
      (async () => {
        // 小程序设置device_cookie
        await this.setMiniProgram();
        // 获取手机号预约状态
        await this.getReservationStatus();
        // 获取主页信息
        await this.getHomePage();
        // 获取价格档位
        // await this.getMemberGoodListH5(false);
        // await this.getOpenPrice(false);

        if (this.$kkmh.ua().kkmh) {
          await this.getMemberGoodListH5(false);
        } else {
          await this.getMemberGoodListBrowser();
        }

        // 获取会员身份
        await this.getVipMe();
      })()
        .then((res) => {
          log("接口初始化完成");
          // 组件请求开始初始化
          this.SET_COMP_INIT(true);
          // 滚动监听
          this.listenScroll();
          // 隐藏骨架屏
          this.hideSkeletonScreen();
          if (refresh != undefined && refresh == "refresh") {
            return false;
          }
          this.$doTrack({
            name: "load",
          });
        })
        .catch((err) => {
          log("接口初始化错误", err);
        });
    },

    // 获取设备和用户相关信息
    setUserAndDeviceInfo: function () {
      const gloalInfo = window.__gvalkkmh;
      const xdevice =
          gloalInfo.sys.device_id != undefined ? gloalInfo.sys.device_id : "",
        muid = gloalInfo.sys.muid,
        can_track = gloalInfo.user.id != 0 ? true : false,
        user_id = gloalInfo.user.id,
        app_info = gloalInfo.sys.app_info,
        app_version = gloalInfo.sys.app_version,
        login =
          gloalInfo.user.id != undefined
            ? gloalInfo.user.id != 0
              ? true
              : false
            : false,
        is_jailbroken_phone = gloalInfo.sys.is_jailbroken_phone;

      this.SET_XDEVICE(xdevice);
      this.SET_IS_LOGIN(login);
      this.SET_CAN_TRACK(can_track);
      this.SET_IS_JAILBROKEN_PHONE(is_jailbroken_phone);
      this.SET_APP_VERSION(app_version);
      this.SET_USERID(user_id);

      this.handleIpad();
    },
    // 判断id
    handleIpad() {
      let ua = navigator.userAgent;
      if (/ipad/.test(ua.toLowerCase())) {
        this.SET_IS_IPAD(true);
      }
    },

    // 监听滚动
    listenScroll() {
      // let eleOffset_btn = document.querySelector(".open_btn_double").offsetTop; // 预约/开通按钮位置
      let eleOffset_btn = document.querySelector(".open_btn_container")
        .offsetTop; // 预约/开通按钮位置

      let eleOffset_tab = document.querySelector(".auth_content").offsetTop; // tab栏下底边位置
      let eleOffset_platform = document.querySelector(".auth_content")
        .offsetTop; // 其他平台栏位置

      // let open_btn_h = document.querySelector(".open_btn_double").clientHeight; // 预约/开通按钮容器的高
      let open_btn_h = document.querySelector(".open_btn_container")
        .clientHeight; // 预约/开通按钮容器的高

      let slide_item_h = document.querySelector(".slide_container")
        .clientHeight; // 展示其他平台元素容器的高

      window.addEventListener("scroll", () => {
        let window_scroll =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop;

        // 开通按钮吸顶
        if (window_scroll >= eleOffset_btn + open_btn_h) {
          this.show_open_fix = true;
        } else {
          this.show_open_fix = false;
        }
        // tab栏吸顶
        if (window_scroll >= eleOffset_tab) {
          this.show_auth_tab = true;
        } else {
          this.show_auth_tab = false;
        }

        // 其他平台栏吸顶
        if (
          window_scroll >= eleOffset_platform + slide_item_h &&
          this.chosen_tab == "other"
        ) {
          this.show_plat_tab = true;
          // document
          //   .querySelector(".plat_top_fix_bar .slide_container")
          //   .scrollTo({
          //     left: 600,
          //     behavior: "smooth",
          //   });
        } else {
          this.show_plat_tab = false;
        }
      });
    },

    // 切换tab
    switchTab(item) {
      if (item == this.chosen_tab) return false;
      this.chosen_tab == "kuaikan"
        ? this.SET_CHOSEN_TAB("other")
        : this.SET_CHOSEN_TAB("kuaikan");

      let map = { kuaikan: "快看漫画特权", other: "其他应用特权" };

      this.$doTrack({ name: map[item] });
    },

    // 点击关闭
    close() {
      if (this.setDetention() && this.is_login) {
        this.showDetention();
      } else {
        this.closePage();
      }
    },

    // 挽留弹窗逻辑
    setDetention() {
      // if (
      //   this.activity_status == 2 &&
      //   this.can_assign_count == 4 &&
      //   this.todayShowDetention()
      // ) {
      //   return true;
      // }

      if (
        this.activity_status == 2 &&
        this.can_assign_count == -1 &&
        this.todayShowDetention()
      ) {
        return true;
      }

      return false;
    },

    // 挽留弹窗，设置storage
    setDetetionStorage() {
      let vist_obj = {
        act_name: "unitMemberDetetion",
        user_id: this.user_id ? this.user_id : 0,
        time: this.server_time,
      };

      localStorage.setItem("unitMemberDetetion", JSON.stringify(vist_obj));
    },

    // 挽留弹窗，读取storage
    getDetetionStorage() {
      return JSON.parse(localStorage.getItem("unitMemberDetetion"));
    },

    // 今日是否显示过挽留弹窗
    todayShowDetention() {
      log(777);
      // 无localstorage-未显示过挽留弹窗
      if (this.getDetetionStorage() == null) {
        this.setDetetionStorage();
        return true;
      }
      let save_day = new Date(this.getDetetionStorage().time).getDate();
      let cur_day = new Date(this.server_time).getDate();
      // 非同一天访问
      if (save_day !== cur_day) {
        this.setDetetionStorage();
        return true;
      }

      return false;
    },

    // 关闭页面
    closePage() {
      this.$kkmh.requestHybrid({
        schema: "kkmhhybrid",
        tagname: "finish",
        callback(res) {},
        param: {
          finish_style: 1, //1-正常关闭 (从左到右滑动关闭),2-直接关闭(无滑动)
        },
      });
    },

    // 显示活动规则
    showRule() {
      let fixele = document.querySelector(".home");
      fix(fixele);

      this.SET_SHOW_RULE(true);

      this.$doTrack({ name: "活动规则" });
    },
    // 显示分享弹窗
    showShare() {
      this.SET_SHOW_SHARE(true);

      this.$doTrack({ name: "页面分享" });
    },

    // 显示挽留弹窗
    showDetention() {
      let fixele = document.querySelector(".home");
      fix(fixele);

      this.SET_SHOW_DETENTION(true);
    },

    // 处理接口返回非200
    handleResErr(res) {
      log(res);
      this.$showToast(res.message);
    },
    // 获取会员身份
    getVipMe(resolve) {
      let headers = {
        "X-Device": this.xdevice,
      };
      return Promise.resolve(
        vipMe({ headers })
          .then((res) => {
            res = this.$formatAxiosRes(res);
            log("获取用户身份", res);
            ![200].includes(res.code) && this.handleResErr(res);
            [200].includes(res.code) && this.handleMemberShip(res, resolve);
          })
          .catch((err) => {
            console.log("获取会员身份错误", err);
          })
      );
    },

    //处理会员身份
    handleMemberShip(res, resolve) {
      let data = res.data;
      //大于0表示是会员，0表示非会员
      let isMember = data.vip.vip_type > 0 ? true : false; //是否是会员
      let vipTypeName = data.vip.vip_group_type_name; //会员身份名称
      let vipGroupType = data.vip.vip_group_type; //会员身份对应type
      let autoKeep = data.vip.auto_keep; //是否自动续费

      log("会员身份", vipTypeName);
      this.SET_MEMBERSHIP_CLASSIFY(vipTypeName);

      this.SET_MEMBER_REMAIN_DAYS(Math.floor(res.data.vip.remained_days / 365));

      if (resolve) {
        return resolve();
      }
    },
    // 获取预约状态
    getReservationStatus() {
      let data = {
        activity_name: this.activity_name,
      };
      let headers = {
        "X-Device": this.xdevice,
      };

      return Promise.resolve(
        phoneReservationStatus({
          data,
          headers,
        })
          .then((res) => {
            res = this.$formatAxiosRes(res);
            log("获取手机号预约状态成功--", res);
            ![200].includes(res.code) && this.handleResErr(res);
            [200].includes(res.code) &&
              this.SET_RESERVATION_STATUS(res.data.reservation_status);
          })
          .catch((err) => {
            log("获取手机号预约状态错误--", err);
          })
      );
    },
    // 获取主页面信息
    getHomePage() {
      let data = {
        activity_name: this.activity_name,
      };
      return Promise.resolve(
        homePage({
          data,
        })
          .then((res) => {
            res = this.$formatAxiosRes(res);
            log("获取主页信息成功--", res);
            ![200].includes(res.code) && this.handleResErr(res);
            [200].includes(res.code) && this.handleHomeData(res.data);
          })
          .catch((err) => {
            log("获取主页信息错误--", err);
          })
      );
    },
    // 处理主页数据
    handleHomeData(data) {
      // 设置服务器时间
      this.SET_SEVER_TIME(data.server_time);
      // 设置活动结束时间
      this.SET_ACTIVITY_END_TIME(data.activity_end_time);
      // 处理平台icon
      this.handlePlateIcon(data.awards);
      // 设置活动阶段
      this.SET_ACTIVITY_STATUS(data.activity_status);
      // 设置剩余开通次数
      this.SET_CAN_ASSIGN_COUNT(data.can_assign_count);
      // 设置售卖总数量
      this.SET_TOTAL_COUNT(data.sale_progress.total_count);
      // 设置已售数量
      this.SET_SALE_COUNT(data.sale_progress.sale_count);

      // // 处理百度进入页面达到了开通4次的上限
      // this.handleBaiduOpen();
    },
    // // 处理百度进入页面达到了开通4次的上限
    // handleBaiduOpen() {
    //   if (this.$kkmh.qs()["from"] != "baidu") {
    //     return;
    //   }
    //   log("百度判断4次");
    //   log("百度判断4次--open_price", this.open_price.id);
    //   if (
    //     this.activity_status == 2 &&
    //     this.can_assign_count != -1 &&
    //     this.open_price.id == 0
    //   ) {
    //     this.baidu_open_disable = true;
    //   }
    // },
    // 处理平台icon
    handlePlateIcon(data) {
      let arr = [];
      data.forEach((item) => {
        // QQ超级会员售空时，下发的award_icon是空，此时不展示QQ超级会员icon
        item.award_icon != "" && arr.push(item);
        // QQ超级会员售空
        item.award_icon == "" &&
          /QQ超级会员/i.test(item.award_title) &&
          this.SET_SHOW_NINE(true);
      });
      // 设置平台icon
      this.SET_PLAT_ICONS(arr);
    },
    // 获取开通会员价格-端外
    getMemberGoodListBrowser() {
      let data = {
        third_activity: this.third_activity,
      };
      let headers = {
        "X-Device": this.xdevice,
      };
      return Promise.resolve(
        h5List({ data, headers }).then((res) => {
          res = this.$formatAxiosRes(res);
          log("端外获取取开通会员价格成功--", res);
          ![200].includes(res.code) && this.handleResErr(res);
          [200].includes(res.code) && this.handleBrowserList(res.data);
        })
      ).catch((err) => {
        log("端外获取开通会员价格错误--", err);
      });
    },
    // 处理开通价格档位-端外
    handleBrowserList(data) {
      let list = data.members[0].recharge_goods;
      let price_obj = {};
      list.forEach((item, index) => {
        let title = /3个月/.test(item.title) ? "3个月" : item.title;
        price_obj[title] = {
          title: title,
          // coupon: this.getCoupon(item.coupon.unreachable_list),
          coupon: this.getCoupon(item.coupon.usable_list),
          id: item.id,
          price: item.real_price / 100,
        };
      });
      let user_price =
        price_obj["3个月"] != undefined
          ? price_obj["3个月"]
          : { title: "", id: "", price: 0 };
      this.SET_OPEN_PRICE(user_price);
    },
    // 获取开通会员价格-端内
    getMemberGoodListH5(compel_iap = false) {
      let data = {
        pay_info: {
          comic_id: this.topic_id, //0, //int 漫画id
          topic_id: this.topic_id, //0, //int 专题id
          source_type: 0, //0,//int 1：签到，2：皇冠，3：作品，4：礼包
          invite_code: "", //'',//string 邀请码
          coupon_id: "", //'', //string 优惠券id
          third_activity: this.third_activity, //'2019act', //添加订单接口，所要传入的活动名称参数
        },
        third_activity: this.third_activity,
        non_iap_supported: this.is_jailbroken_phone_url, //运营位是否支持越狱，1表示支持
        compel_iap: compel_iap, // 是否强制iap
        non_iap_supported_device: this.is_jailbroken_phone,
        platform: this.$kkmh.ua().kkmh ? (this.$kkmh.ua().iphone ? 2 : 1) : "", // 1-安卓，2-ios，3-h5，
      };
      let headers = {
        "X-Device": this.xdevice,
      };
      return Promise.resolve(
        listH5({ data, headers })
          .then((res) => {
            res = this.$formatAxiosRes(res);
            log("端内获取取开通会员价格成功--", res);
            ![200].includes(res.code) && this.handleResErr(res);
            [200].includes(res.code) && this.handleMemberGoodList(res.data);
          })
          .catch((err) => {
            log("端内获取开通会员价格错误--", err);
          })
      );
    },
    // 处理开通价格档位-端内
    handleMemberGoodList(data) {
      let list = data.members[0].member_goods;
      let price_obj = {};
      list.forEach((item, index) => {
        let title = /3个月/.test(item.title) ? "3个月" : item.title;
        price_obj[title] = {
          title: title,
          // coupon: this.getCoupon(item.coupon.unreachable_list),
          coupon: this.getCoupon(item.coupon.usable_list),
          id: item.id,
          price: item.price.real_price / 100,
        };
      });
      let user_price =
        price_obj["3个月"] != undefined
          ? price_obj["3个月"]
          : { title: "", id: "", price: 0, coupon: { id: "", amount: 0 } };
      this.SET_OPEN_PRICE(user_price);
    },
    // 获得最大额度优惠券
    getCoupon(list) {
      let allList = {};
      let allPrice = [];
      if (list.length == 0) {
        return {
          amount: 0,
          id: 0,
        };
      }
      list.forEach((item, index) => {
        allList[item.amount] = item;
        allPrice.push(item.amount);
      });

      let sortList = allPrice.sort((a, b) => {
        return b - a;
      });
      return allList[sortList[0]];
    },

    // 是否在小程序中
    isMiniProgram() {
      let is_mini = {
        wechatmini: window.__gvalkkmh.ua.wechatmini,
        qqmini: window.__gvalkkmh.ua.qqmini,
        baidumini: window.__gvalkkmh.ua.baidumini,
      };
      return is_mini;
    },
    // 点击开通会员
    callOutAppPay() {
      this.SET_CALL_APPPAY(true);
    },

    // 跳转领取页
    jumpToGetPage() {
      let charge_activity_name = this.activity_name,
        activity_name = this.activity_name_topic,
        origin = this.origin,
        eruda = /kuaikanmanhua/.test(location.host)
          ? `eruda=${false}`
          : `eruda=${true}`;
      let topage = `${location.protocol}//${location.host}/act/link_vip_assign_list?conf2fullscreen=1&conf2scrollwhitearea=1&charge_activity_name=${charge_activity_name}&activity_name=${activity_name}&origin=${origin}&${eruda}&serviceType=pay`;

      if (
        this.isMiniProgram()["wechatmini"] ||
        this.isMiniProgram()["qqmini"] ||
        this.isMiniProgram()["baidumini"]
      ) {
        let miniPramUrl = `/pages/webview/webview?type=19&url=${encodeURIComponent(
          topage
        )}`;
        miniprogramNav(miniPramUrl);
        // location.href = topage;
      } else {
        location.href = topage;
      }
    },
    // 跳转百度
    jumpBaidu() {
      log("跳转百度");
      if (this.isMiniProgram()["baidumini"]) {
        swan.navigateToSmartProgram({
          appKey: "zGrnz5ZkPm3ricdEqIArH4KCbxVQtu2S",
          path: "pages/index/index",
          success: (res) => {
            log("跳转百度成功", res);
          },
          fail: (err) => {
            log("跳转百度失败", err);
          },
        });

        // location.href="baiduboxapp://swan/zGrnz5ZkPm3ricdEqIArH4KCbxVQtu2S_dev20/pages/index/index"
      } else {
        location.href =
          "https://smartprogram.baidu.com/developer/activity/unitedmember/index.html";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./css/common.scss";
.home {
  width: 100%;
  height: 100%;
  max-width: trans(750);
  background-image: url("./img/bg.png");
  background-size: 100%;
  background-repeat: no-repeat;
  padding-bottom: trans(182);
  margin: 0 auto;
  overflow-x: hidden;
}
.home_out_app {
  margin-top: trans(-20);
}
.top_bar {
  @include boxsize(690, 64);
  @include layout(space-between, center);
  margin: 0 auto;
  // margin-top: trans(52);
  margin-top: trans(60);
  .back_btn {
    @include boxsize(64, 64);
    @include layout(flex-start, center);
    background-color: rgba(160, 43, 39, 0.85);
    border-radius: 50%;
    img {
      @include boxsize(18, 31);
      display: block;
      margin-left: trans(20);
    }
  }
  .share_btn {
    @include boxsize(122, 58);
    @include layout(center, center);
    background-color: rgba(160, 43, 39, 0.85);
    border-radius: trans(29);
    img {
      @include boxsize(78, 30);
      display: block;
    }
  }
}
.banner {
  @include boxsize(653, 154);
  margin: 0 auto;
  margin-top: trans(-9);
  img {
    display: block;
    width: 100%;
  }
}

.rule_entrance {
  @include boxsize(40, 124);
  @include fontstyle(#fff, 22);
  @include layout(center, center);
  line-height: 1.15;
  background-color: rgba(143, 25, 22, 0.85);
  border-radius: trans(17) 0 0 trans(17);
  position: absolute;
  right: 0;
  z-index: 1;
  margin-top: trans(-30);
  div {
    width: trans(20);
  }
}
.auth_top_fix_bar {
  // @include boxsize(750, 72);
  @include layout(space-between, center);
  @include hcenter(750);
  width: trans(750);
  position: fixed;
  top: trans(-72);
  // left: 0;
  z-index: 2;
  transition: all 0.2s ease-in-out;
  .kuaikan_tab,
  .other_tab {
    @include boxsize(375, 72);
    @include layout(center, center);
    background-color: #ff4031;
  }
  .tab_chosen {
    background-color: #fee551;
  }
  .kuaikan_unchosen,
  .other_unchosen {
    @include boxsize(179, 30);
    display: block;
  }
  .kuaikan_chosen,
  .other_chosen {
    @include boxsize(264, 41);
    display: block;
  }
}
.auth_top_fix_bar_show {
  top: 0;
}
.plat_top_fix_bar {
  @include boxsize(750, 154);
  @include layout(center, center);
  background-color: #fdf7e7;
  position: fixed;
  top: trans(-226);
  left: 0;
  transition: all 0.5s ease-in-out;
}
.plat_top_fix_bar_show {
  top: trans(72);
}
.bottom_fix_bar {
  @include boxsize(750, 140);
  background-color: #ff3e25;
  position: fixed;
  bottom: trans(-140);
  border-top-left-radius: trans(50);
  border-top-right-radius: trans(50);
  transition: all 0.2s ease-in-out;

  .open_btn_fix {
    @include boxsize(653, 100);
    margin: 0 auto;
    margin-top: trans(20);
  }
}
.bottom_fix_bar_show {
  bottom: 0;
}

.end_page {
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
  .back_btn {
    @include boxsize(64, 64);
    @include layout(flex-start, center);
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 50%;
    position: absolute;
    left: trans(25);
    top: trans(25);
    img {
      @include boxsize(18, 31);
      display: block;
      margin-left: trans(20);
    }
  }
  .end_content {
    @include boxsize(236, 366);
    @include vhcenter(236, 366);
    position: absolute;
    .end_icon {
      @include boxsize(236, 288);
      display: block;
    }
    .end_tips {
      @include fontstyle(#8b8b8b, 25);
      text-align: center;
    }
  }
}

.auth_top_fix_bar_android .kuaikan_tab,
.auth_top_fix_bar_android .other_tab {
  padding-top: trans(50);
}

.plat_top_kuaikan_app_full_android {
  padding-top: trans(50);
}

.baidu_mask {
  background-image: url("./img/baidu-mask.png");
  background-size: 100%;
  // opacity: 0.5;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #f3f3f3;
  z-index: 999;
  .dard_mask {
    width: 100%;
    height: 100%;
    position: fixed;
    background-color: rgba(0, 0, 0, 0.8);
  }
  .baidu_btn_container {
    @include vcenter(100);
    width: trans(750);
    position: absolute;
    .from_baidu_btn {
      // margin-top: trans(50);
    }

    .from_baidu_open_btn {
      @include boxsize(400, 80);
      @include layout(center, center);
      @include fontstyle(#422222, 40);
      // @include hcenter(400);
      // position: absolute;
      font-weight: bold;
      border-radius: trans(50);
      background-color: #fee43f;
      margin: 0 auto;
      margin-bottom: trans(30);
    }
    .from_baidu_get_btn {
      @include boxsize(400, 80);
      @include layout(center, center);
      // @include hcenter(400);
      @include fontstyle(#422222, 40);
      font-weight: bold;
      border-radius: trans(50);
      background-color: #fee43f;
      margin: 0 auto;
      margin-bottom: trans(30);
    }
    .form_baidu_double_btn {
      margin: 0 auto;
      .from_baidu_get_btn_left {
        @include boxsize(400, 80);
        @include layout(center, center);
        border-radius: trans(40);
        background-color: #fee43f;
        font-weight: bold;
        margin: 0 auto;
        margin-bottom: trans(30);
      }
      .from_baidu_get_btn_right {
        @include boxsize(400, 80);
        @include layout(center, center);
        @include fontstyle(#422222, 40);
        border-radius: trans(40);
        background-color: #fee43f;
        font-weight: bold;
        margin: 0 auto;
        margin-bottom: trans(30);
      }
    }

    .from_baidu_disable_btn {
      @include boxsize(400, 80);
      @include layout(center, center);
      border-radius: trans(40);
      margin: 0 auto;
      margin-bottom: trans(30);
      background-color: #aaaaaa;
      font-weight: bold;
    }

    .back_baidu_btn {
      @include boxsize(400, 80);
      @include layout(center, center);
      @include fontstyle(#422222, 40);
      border-radius: trans(40);
      margin: 0 auto;
      background-color: #fee43f;
      font-weight: bold;
    }
  }
}

/* x xs */
@media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
  .bottom_fix_bar_show_app_full {
    padding-bottom: trans(60);
  }
}

/* xr */
@media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) {
  .bottom_fix_bar_show_app_full {
    padding-bottom: trans(60);
  }
}

/* xs max */
@media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) {
  .bottom_fix_bar_show_app_full {
    padding-bottom: trans(60);
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/act/202010/unit_member/app.vue